export const userGroupConstants = {
  USER_GROUP_CREATE_LOADING: 'USER_GROUP_CREATE_LOADING',
  USER_GROUP_CREATE_SUCCESS: 'USER_GROUP_CREATE_SUCCESS',
  USER_GROUP_CREATE_FAILURE: 'USER_GROUP_CREATE_FAILURE',
  USER_GROUP_ERROR_RELOAD: 'USER_GROUP_ERROR_RELOAD',

  USER_GROUP_LIST_LOADING: 'USER_GROUP_LIST_LOADING',
  USER_GROUP_LIST_SUCCESS: 'USER_GROUP_LIST_SUCCESS',
  USER_GROUP_LIST_FAILURE: 'USER_GROUP_LIST_FAILURE',
  USER_GROUP_LIST_CLEAR: 'USER_GROUP_LIST_CLEAR',

  USER_GROUP_EDIT_LOADING: 'USER_GROUP_EDIT_LOADING',
  USER_GROUP_EDIT_SUCCESS: 'USER_GROUP_EDIT_SUCCESS',
  USER_GROUP_EDIT_FAILURE: 'USER_GROUP_EDIT_FAILURE',

  USER_GROUP_DELETE_LOADING: 'USER_GROUP_DELETE_LOADING',
  USER_GROUP_DELETE_SUCCESS: 'USER_GROUP_DELETE_SUCCESS',
  USER_GROUP_DELETE_FAILURE: 'USER_GROUP_DELETE_FAILURE'
};
